import { render, staticRenderFns } from "./GNumeric.vue?vue&type=template&id=850144b2"
import script from "./GNumeric.vue?vue&type=script&lang=js"
export * from "./GNumeric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports